import { api } from 'src/api/axios';
import { LoginRequest, AuthResponse, UserResponse } from './interfaces/auth';

export const authService = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  register: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/register', data);
    return response.data;
  },

  getMe: async (): Promise<UserResponse> => {
    const response = await api.get<UserResponse>('/auth/me');
    return response.data;
  },

  forgotPassword: async (email: string): Promise<void> => {
    await api.post('/auth/password/forgot', { email });
  },

  resetPassword: async (data: { token: string; password: string; rpt: number }): Promise<void> => {
    await api.post('/auth/password/reset', data);
  },
};